import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
import { displayFontFamily } from '@client/theme';
export const SectionTitle = (props) => (_jsx(Text, { fontSize: 32, fontWeight: 500, fontFamily: displayFontFamily, children: props.children }));
